import { Sidebar } from "primereact/sidebar";
import commonStyle from "../../content/CommonStyles.module.css";
import { useFormik } from "formik";
import useApi from "../../../Utils/BackendClient";
import { DisplayErrors } from "../../../Utils/ErrorHandler";
import { Button } from "primereact/button";
import TextInput from "../Inputs/TextInput";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import NewValueCreationSidebar from "./NewValueCreationSidebar";
import { useState } from "react";
import { confirmPopup, ConfirmPopup } from "primereact/confirmpopup";

const CustomDictionaryCreationSideBar = ({ visible, onHide, toast, data, additionalActions }) => {

    const [newValueSideBarVisible, setNewValueSideBarVisible ] = useState(false);

    const { createCustomDictionary, updateCustomDictionary } = useApi(); 

    const formik = useFormik({
        initialValues: data ?? {
            name: "",
            items: []
        },
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            if (!values.name) {
                errors.name = "Введіть назву довідника"
            }

            return errors;
        },
        onSubmit: async (values) => {

            const response = data ? await updateCustomDictionary(values.id, values) : await createCustomDictionary(values);

            const successStatus = data ? 200 : 201;

            if (response.status === successStatus) {
                
                if(data){
                    toast.current.show({ severity: "success", summary: "Успіх", detail: `Словник успішно відредаговано`, life: 3000 });
                }
                else{
                  toast.current.show({ severity: "success", summary: "Успіх", detail: `Словник успішно створено`, life: 3000 });                  
                }

                formik.resetForm();
                onHide();
                additionalActions();
            }
            else {
                DisplayErrors(response.error, toast);
            }
        }
    });

    const AddValueToItems = (value) => {
        const item = {
            value: value
        }
        const newItems = [...formik.values.items, item];
        formik.setFieldValue("items", newItems);

        setNewValueSideBarVisible(false);
    }

    const DeleteFieldFromTable = (rowData) => {
        const newItems = formik.values.items.filter(x => x.value !== rowData.value);
        formik.setFieldValue("items", newItems);
    }

    const confirmDelete = (event, rowData) => {
        confirmPopup({
            group: 'headless',
            target: event.currentTarget,
            message: 'Підтвердження видалення значення ' + rowData.value,
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            acceptLabel: "Так",
            rejectLabel: "Hi",
            accept: () => { DeleteFieldFromTable(rowData) }
        });
    }

    const ValueTableHeader = () => {
        return (
            <div className="flex flex-wrap align-items-center justify-content-between gap-2">
                <div>Значення довідника</div>
                <Button
                    icon="pi pi-plus"
                    type="button"
                    className={`p-button-rounded p-button-success ${commonStyle.addButton}`}
                    tooltipOptions={{ position: "left" }}
                    tooltip="Створити товар"
                    onClick={() => setNewValueSideBarVisible(true)}
                />
            </div>)
    }

    const actionBodyTemplate = rowData => {
        return (<div className="flex flex-wrap gap-2 justify-content-end">
            <Button
                icon="pi pi-times"
                className={`p-button-rounded p-button-danger ${commonStyle.deleteButton}`}
                type="button"
                onClick={(event) => { confirmDelete(event, rowData) }}
            />
        </div>
        );
    };

    return (<>
        <Sidebar visible={visible} position="right" className={commonStyle.sidebar} onHide={onHide} header={<h3>Меню додавання довідника</h3>}>
            <form onSubmit={formik.handleSubmit}>
                <TextInput formik={formik} paramName={"name"} label={"Назва довідника"} mandatory customStyle="w-full" />
                <DataTable value={formik.values.items} header={ValueTableHeader}>
                    <Column field="value" headerStyle={{ display: 'none' }} style={{ width: '70%' }} />
                    <Column field="action" headerStyle={{ display: 'none' }} body={actionBodyTemplate} style={{ width: '30%' }} />
                </DataTable>
                <Button label="Зберегти" severity="success" type="submit" className={`${commonStyle.sideBarButton} ${commonStyle.addButton}`} autoFocus />
            </form>
        </Sidebar>
        <NewValueCreationSidebar visible={newValueSideBarVisible} onHide={() => setNewValueSideBarVisible(false)} onSelect={(value) => AddValueToItems(value)}/>
        <ConfirmPopup group="headless" />
        </>
    );
}

export default CustomDictionaryCreationSideBar;